import styled from "@emotion/styled";

export const TextBody = styled("div")({ width: 400 });
